<template>
  <section>
    <div
      @click="showEventDetails()"
      class="calendarDayItem"
      v-if="checkStartDate || checkStartWeek"
    >
      <div class="calendarItem" :style="style">
        <p>{{ event.title }}</p>
      </div>
      <div
        v-if="event.showDetails && !this.showMulti"
        class="detailBox"
        :style="detailStyle"
      >
        <EventDetails :event="this.event" />
      </div>
    </div>
    <div v-else class="emptyItem">
      <div class="blankCalendarItem" :style="blankStyle" v-if="checkBlank">
        <p>{{ event.title }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import EventDetails from "@/components/calendar/EventDetails";

export default {
  props: ["event", "day", "events", "index"],

  components: {
    EventDetails,
  },

  data: () => ({}),
  mounted() {},

  computed: {
    ...mapState("calendar", ["showMulti"]),
    style() {
      var weeks = this.setEventWeeks(this.event.startDate, this.event.endDate);
      var weekDays = {};
      var days =
        (this.event.endDate - this.event.startDate) / (1000 * 3600 * 24);
      var multiDay = 0;
      var color = "";

      switch (this.event.type) {
        case "class":
          color = "#16a085";
          break;
        case "assessment":
          color = "#e74c3c";
          break;
        case "assignment":
          color = "#f39c12";
          break;
        case "office":
          color = "#0984e3";
          break;
        case "other":
          color = "#a55eea";
          break;
      }

      for (var i = 0; i < weeks.length; i++) {
        weekDays[weeks[i]] = 0;
        for (var j = 0; j <= days; j++) {
          var dayDif = j * 86400000;
          if (moment(this.event.startDate + dayDif).week() == weeks[i]) {
            weekDays[weeks[i]] += 1;
          }
        }
      }
      if (weekDays[this.day.week] > 1) {
        multiDay = 0.4 * weekDays[this.day.week];
      }
      var shadow = "none";
      if (this.event.showDetails) {
        shadow = "1px 1px 6px #a0a0a0";
      }
      return {
        width: 98 + (100 * (weekDays[this.day.week] - 1) + multiDay) + "%",
        "background-color": color,
        "box-shadow": shadow,
      };
    },

    blankStyle() {
      return {
        width: 98 + "%",
        "background-color": "#16a085",
      };
    },
    detailStyle() {
      let x = this.day.weekNum > 2 ? -100 : 40;
      let y = this.index > 2 ? -20 : 0;
      //x = 0;
      //y = 0;
      return {
        transform: "translate(" + x + "%, " + y + "%)",
      };
    },
    checkStartDate() {
      if (this.event.startDate) {
        let startDay = Number(moment(this.event.startDate).format("D"));
        let startMonth = moment(this.event.startDate).month();
        if (startDay == this.day.num && startMonth == this.day.month) {
          return true;
        }
      }
      return false;
    },
    checkMultiWeek() {
      if (this.event.startDate != null) {
        var weeks = this.setEventWeeks(
          this.event.startDate,
          this.event.endDate
        );
        if (weeks.length > 1) {
          return true;
        }
      }
      return false;
    },

    checkStartWeek() {
      if (this.event.startDate != null) {
        if (this.day.weekNum == 0) {
          return true;
        }
      }
      return false;
    },
    checkBlank() {
      if (this.event.startDate == null) {
        return true;
      }
      return false;
    },
    checkEmpty() {
      if (this.event.startDate == null && this.event.name == null) {
        return true;
      }
      return false;
    },
  },

  methods: {
    getDateInMs(date) {
      return new Date(date).getTime();
    },

    showEventDetails() {
      this.event.showDetails = !this.event.showDetails;
      this.$store.commit("calendar/setShowMulti", false);
      this.hidePreviousEventDetails(this.event);
    },

    hidePreviousEventDetails(event) {
      for (const index in this.events) {
        if (this.events[index] != event) {
          this.events[index].showDetails = false;
        }
      }
    },

    setEventWeeks(startDate, endDate) {
      var startWeek = moment(startDate).week();
      var endWeek = moment(endDate).week();
      var weeks = [];

      for (var week = startWeek; week <= endWeek; week++) {
        weeks.push(week);
      }
      return weeks;
    },
  },
};
</script>

<style scoped>
.detailBox {
  position: absolute;
  left: 0;
  top: 0;
}
p {
  color: white;
  font-size: 12px;
}

.emptyItem {
  padding: 10px 0px;
  pointer-events: none;
}

.calendarItem {
  position: relative !important;
  margin: 2px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  left: 0;
  cursor: pointer;
  white-space: nowrap;
}

.blankCalendarItem {
  margin: 0 2px 2px 0px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  margin-top: -10px;
  box-shadow: 1px 1px 6px #a0a0a0;
  z-index: 5;
}

.calendarBlock {
  position: relative;
  background-color: transparent;
  margin: 0 2px 2px 0px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  z-index: 2;
}

.red {
  color: transparent;
}
</style>
